import { useStaticQuery, graphql } from "gatsby"

const useTeamMemberQuery = () => {
  const { allDatoCmsTeamMember } = useStaticQuery(graphql`
  query Agents {
    allDatoCmsTeamMember(
      filter: {hideForLocale: {ne: true}}
      sort: {position: ASC}
    ) {
      nodes {
        id
        originalId
        title
        jobTitle
        biography {
          value
        }
        sector {
          option
        }
        hideForLocale
        image {
          ...InternalAssetProps
        }
      }
    }
  }
`)

  return allDatoCmsTeamMember.nodes
}

export default useTeamMemberQuery